// Fetch Featured Content for a given set of metadataIds
function fetch(apiClient, results) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/featuredContent`;
  return apiClient.get(route, { query: { metadataIds: results.toArray() } });
}

export default { fetch };



// WEBPACK FOOTER //
// ./app/api/FeaturedContentApi.js